import React, { MouseEventHandler } from "react";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import Button from "components/Button/Button";

interface OtpBackButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
}

const OtpBackButton = ({ onClick }: OtpBackButtonProps) => (
  <Button
    onClick={onClick}
    icon={<ArrowLeftIcon className="text-slate-500 h-4 w-4" />}
    type="roundedBlack"
    className="lg:mr-0 md:mr-0 mb-8"
  />
);

export default OtpBackButton;
